<div class="change-parent sidenav" id="mySidenav" [style.height.px]="myHeight" [style.width.%]="myWidth" (click)="close()"></div>
  <div class= "changeAcc" [style.height.px]="myHeight" [style.width.px]="Width">
      <div class="customer-title">
        {{ "userData.customerAccount" | cxTranslate }}
        <span class="material-icons" role="button" (click)="close()">close</span>
      </div>
      <div class="customer-desc-text" *ngIf="!showEntity">
        {{ "userData.updateEntity" | cxTranslate }}
      </div>
      <div class="customer-desc-text" *ngIf="showEntity">
        {{ "userData.searchDescription" | cxTranslate }}
      </div>
      <div *ngIf="!this.changeLegalEntity && !this.showEntity">
        <div *ngIf="b2BAccount$ | async as b2bacounts else loading">
          <div *ngFor="let b2BAccount of b2bacounts.b2bUnits; let i = index">
            <div *ngIf="b2BAccount.isDefaultB2bUnit">
                <div class="current-customer" *ngIf="!showEntity">{{ "userData.currentAccount" | cxTranslate }}</div>
                <div class="customer-name name-text">{{b2BAccount.name}}</div>
                <div class="customer-no">{{b2BAccount.uid}}</div>
                <div *ngFor="let salesArea of b2BAccount.vsSalesArea; let i = index">
                  <div *ngIf="salesArea.isDefaultVsSalesArea">
                      <div class="customer-name sales-txt">{{salesArea.salesOrganization}} -
                        {{salesArea.division}}
                      </div>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    <div *ngIf="this.changeLegalEntity && !this.showEntity">
        <div class="current-customer" *ngIf="!showEntity">{{ "userData.currentAccount" | cxTranslate }}</div>
        <div class="customer-name">{{this.name}}</div>
        <div class="customer-no">{{this.userId}}</div>
        <!-- <div class="customer-no">{{this.address}}</div> -->
    </div>
    <div *ngIf="this.showEntity">
      <div class="customer-name-showEntity">{{this.name}}</div>
      <div class="customer-no">{{this.userId}}</div>
      <div class="entity-fav" *ngIf="this.favorite" (click)="remove()">
        <i class="material-icons">star</i>
        {{ "userData.removeFav" | cxTranslate }}
      </div>
      <div class="entity-fav" *ngIf="!this.favorite" (click)="addToFav()">
        <i class="material-icons">star_border</i>
        {{ "userData.addFav" | cxTranslate }}
      </div>
  </div>
      <div *ngIf="!showEntity">
        <div class="ter-btn-holder">
            <button class="vs-tertiary-btn" (click)="changeEntity()">
              {{ "userData.changeEntity" | cxTranslate }}     
          </button>
        </div>
        <div class="change-account">{{ "userData.changeCustAccount" | cxTranslate }}</div>
        <mat-tab-group (selectedTabChange)="tabClick($event,search)" class="customer-tab">
          <mat-tab>
            <ng-template mat-tab-label class="recent">
              <span class="material-icons">history</span>
              <span class="tab-txt"> {{ "userData.recent" | cxTranslate }}</span>
            </ng-template>
            <div class="customer-data">
              <div *ngIf="recents$ | async as recents else loading" class="scroll-data" [style.max-height.px]="maxHeight">
                <div class="data" *ngFor="let company of recents?.b2bUnits">
                    <div class="data-name">{{ company.name }}</div>
                    <div *ngIf="!company.isDefaultB2bUnit" class="ter-btn-holder">
                      <button class="vs-tertiary-btn" (click)="selectRecent(company)">{{ "userData.select" | cxTranslate }}</button>                      
                    </div>
                    <button *ngIf="company.isDefaultB2bUnit" class="vs-primary-btn sample-btn" (click)="selectRecent(company)">
                      <span>{{ "userData.selected" | cxTranslate }}</span>
                    </button>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label class="favorite">
              <span class="material-icons">star_border</span>
              <span class="tab-txt">{{ "userData.favorties" | cxTranslate }}</span>
            </ng-template>
            <div class="customer-data">
              <div *ngIf="favourite$ | async as favourites else loading" class="scroll-data" [style.max-height.px]="maxHeight">
                <div class="data" *ngFor="let company of favourites?.b2bUnits">
                  <div class="data-name">{{ company.name }}</div>
                  <div *ngIf="!company.isDefaultB2bUnit" class="ter-btn-holder">
                    <button class="vs-tertiary-btn" (click)="selectRecent(company)">{{ "userData.select" | cxTranslate }}</button>                      
                  </div>
                  <button *ngIf="company.isDefaultB2bUnit" (click)="selectRecent(company)" class="vs-primary-btn sample-btn">
                    <span>{{ "userData.selected" | cxTranslate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="material-icons">search</span>
              <span class="tab-txt">{{ "userData.search" | cxTranslate }}</span>
            </ng-template>
            <div class="customer-data">
              <div class="search">
                <input type="text" class="form-control search-btn"  placeholder="Enter a minimum of 3 characters to search by Customer Account Number" 
                 #search name="search" [(ngModel)]="term" (keypress)="keyPress(search)">
                <span><i class="material-icons search-icon" (click)="modelChange(search)">search</i></span>                
            </div>
            <div *ngIf="searchDone">
                <div *ngIf="searchList$ | async as searchList else loading" class="scroll-data" [style.max-height.px]="maxHeightSearch">
                  <div class="data" *ngFor="let company of searchList.b2bUnits">
                    <div class="data-name">{{ company.name }}</div>
                    <div *ngIf="!company.isDefaultB2bUnit" class="ter-btn-holder">
                      <button class="vs-tertiary-btn" (click)="selectRecent(company)">{{ "userData.select" | cxTranslate }}</button>                      
                    </div>
                    <button *ngIf="company.isDefaultB2bUnit" (click)="selectRecent(company)" class="vs-primary-btn sample-btn">
                      <span>{{ "userData.selected" | cxTranslate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div *ngIf="showEntity">
        <vs-change-legal-entity
        [selectId]="this.selectId"
         [legalEntitis]="this.userId"
         [legalEntitisListss] = "this.legalEntitisList"
         [defaultEntity]="this.defaultEntity"
          (selectedLegalEntity)="selectedLegalEntity($event)"
          [changeFlag]="changeFlag"
          context="currency"
          (closePage)="closePage($event)"></vs-change-legal-entity>
      </div>
    </div>
    <ng-template #loading>
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    </ng-template>
  
